import BaseStarRating from 'components/Shared/StarRating';
import { colors } from 'components/styles/variables';
import numeral from 'numeral';

export interface StarRatingProps {
  value: number;
  color?: 'red' | 'gold';
}

export default function StarRating(props: StarRatingProps): JSX.Element {
  return (
    <>
      <div className="overall-stars">
        <BaseStarRating value={props.value} isGold={props.color === 'gold'} />
        <div className="overall-rating">{numeral(props.value).format('0.0')}</div>
      </div>
      <style jsx>{`
        .overall-rating-container {
          display: flex;
          flex-direction: column;
          margin-bottom: 42px;
          height: 26px;
        }
        .overall-stars {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding-bottom: 4px;
        }
        .overall-rating {
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          text-align: center;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
          padding-left: 5px;
        }
      `}</style>
    </>
  );
}
